import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import { GetSingleKodepayVA, reset } from "../../../features/kodepayVASlice";

import Select from "react-select";
import { Card, Button, Form, Col, Row } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import api from "../../../api";
import {
  formatNumber,
  getYearsList,
  removeFormatter,
  removeTrailingZero,
} from "../../../helpers/helper";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import { Link } from "react-router-dom";

const FormKodepayVAPage = () => {
  const [dataFakultas, setDataFakultas] = useState([]);
  const [dataProdi, setDataProdi] = useState([]);
  const [newData, setNewData] = useState({
    kode: "",
    id_fakultas: "",
    id_prodi: "",
    deskripsi: "",
    nominal: null,
    nominalMask: null,
    cicilan: false,
    periode_mulai: null,
  });

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.kodepayVA);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());
    if (id) {
      dispatch(GetSingleKodepayVA({ id, token }));
    }
  }, [id, dispatch, token]);

  // call on init
  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Ambil data fakultas
        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });

        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));
        setDataFakultas(fakultasFormated);
      } catch (error) {
        console.log("ERROR FETCH FAKULTAS : ", error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [id, token]);

  // call if the id_fakultas is changed
  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Jika newUser.id_fakultas tidak kosong, ambil data prodi
        if (newData.id_fakultas) {
          const prodiResponse = await axios.get(
            `${api}/master/prodi/get_by_fakultas_id/${newData.id_fakultas}`
          );
          const prodiFormated = prodiResponse.data.data.map((prodi) => ({
            value: prodi.id,
            label: prodi.nama,
          }));
          setDataProdi(prodiFormated);
        } else {
          // Jika newUser.id_fakultas kosong, set dataProdi menjadi array kosong
          setDataProdi([]);
        }
      } catch (error) {
        console.log("ERROR FETCH PRODI : ", error);
      }
    };

    fetchData();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [newData.id_fakultas]);

  useEffect(() => {
    if (id) {
      const copyData = Object.assign(
        { ...data?.data },
        {
          nominalMask: removeTrailingZero(data?.data?.nominal),
        }
      );
      setNewData(copyData);
    }
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}master/kode_payment/${id}`,
              {
                kode: newData.kode,
                id_prodi: newData.id_prodi,
                deskripsi: newData.deskripsi,
                nominal: newData.nominal,
                cicilan: newData.cicilan,
                periode_mulai: newData.periode_mulai,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}master/kode_payment`,
              {
                kode: newData.kode,
                id_prodi: newData.id_prodi,
                deskripsi: newData.deskripsi,
                nominal: newData.nominal,
                cicilan: newData.cicilan,
                periode_mulai: newData.periode_mulai,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate(
            `/master/${param.pathname.split("/")[2]}/list/${
              newData.periode_mulai
            }`
          );
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header title="Detail Kode Payment VA">
            <Button
              as={Link}
              variant="outline-primary"
              size="sm"
              to={`/master/${param.pathname.split("/")[2]}/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header title="Tambah Kode Payment VA">
            <Button
              as={Link}
              variant="outline-primary"
              size="sm"
              to={`/master/${param.pathname.split("/")[2]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header title="Edit Kode Payment VA">
            <Button
              as={Link}
              variant="outline-primary"
              size="sm"
              to={`/master/${param.pathname.split("/")[2]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Card border="light" className="shadow-sm mb-4">
          {param.pathname.split("/")[3] === "view" ? (
            <FormPage
              newData={newData}
              setNewData={setNewData}
              handleSubmit={handleSubmit}
              isLocked={true}
              dataProdi={dataProdi}
              dataFakultas={dataFakultas}
            />
          ) : param.pathname.split("/")[3] === "add" ? (
            <FormPage
              newData={newData}
              setNewData={setNewData}
              handleSubmit={handleSubmit}
              dataProdi={dataProdi}
              dataFakultas={dataFakultas}
            />
          ) : param.pathname.split("/")[3] === "edit" ? (
            <FormPage
              newData={newData}
              setNewData={setNewData}
              handleSubmit={handleSubmit}
              dataProdi={dataProdi}
              dataFakultas={dataFakultas}
            />
          ) : null}
        </Card>
      )}
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  handleSubmit,
  dataFakultas,
  dataProdi,
}) => {
  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="kode">
              <Form.Label>Kode</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Kode"
                name="kode"
                disabled={isLocked}
                value={newData.kode || ""}
                onChange={(e) =>
                  setNewData({ ...newData, kode: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="prodi">
              <Form.Label>Fakultas</Form.Label>
              <Select
                isDisabled={isLocked}
                options={dataFakultas}
                placeholder="Pilih Fakultas"
                disabled={isLocked}
                value={dataFakultas.find(
                  (item) => item.value === newData.id_fakultas
                )}
                isClearable
                onChange={(e) =>
                  setNewData({ ...newData, id_fakultas: e?.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="prodi">
              <Form.Label>Prodi</Form.Label>
              <Select
                isDisabled={isLocked}
                options={dataProdi}
                value={dataProdi.find(
                  (item) => item.value === newData.id_prodi
                )}
                placeholder="Pilih Prodi"
                disabled={isLocked}
                isClearable
                onChange={(e) => setNewData({ ...newData, id_prodi: e?.value })}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="deskripsi">
              <Form.Label>Deskripsi</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Deskripsi"
                name="deskripsi"
                disabled={isLocked}
                value={newData.deskripsi || ""}
                onChange={(e) =>
                  setNewData({ ...newData, deskripsi: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="nominal">
              <Form.Label>Nominal</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="0"
                name="nominal"
                disabled={isLocked}
                value={newData.nominalMask || ""}
                onChange={(e) =>
                  setNewData({
                    ...newData,
                    nominal: removeFormatter(e.target.value),
                    nominalMask: formatNumber(e.target.value),
                  })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="cicilan">
              <Form.Check
                type="checkbox"
                label="Bisa dicicil?"
                checked={newData.cicilan || false}
                disabled={isLocked}
                onChange={(evt) =>
                  setNewData({ ...newData, cicilan: evt.target.checked })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group className="mb-3" id="periode_mulai">
              <Form.Label>Periode Mulai</Form.Label>
              <Select
                options={getYearsList()}
                placeholder="Pilih Periode Mulai"
                required
                value={getYearsList().find(
                  (item) => `${item.value}` === `${newData.periode_mulai}`
                )}
                isDisabled={isLocked}
                onChange={(e) => {
                  setNewData({ ...newData, periode_mulai: e.value });
                }}
              />
            </Form.Group>
          </Col>
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit">{id ? "Update" : "Simpan"}</Button>
          ) : null}
        </div>
      </Form>
    </Card.Body>
  );
};

export default FormKodepayVAPage;
